import { Component, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** ErrorBoundary global (UI-01) : aucun bug n'aboutit à un écran blanc. */
class Boundary extends Component<{ fallback: ReactNode; children: ReactNode }, { hasError: boolean }> {
  override state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  override render(): ReactNode {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const fallback = (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <p className="text-muted">{t('error.boundary')}</p>
      <button onClick={() => location.reload()} className="rounded-lg bg-accent px-4 py-2 text-accent-fg">
        {t('error.reload')}
      </button>
    </div>
  );
  return <Boundary fallback={fallback}>{children}</Boundary>;
}
